import { Badge, Box, Column, Columns, Text, Inline } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';
import * as styles from './BucketButton.css';
import { useStores } from 'src/utils/hooks/useStores';
import useQueryParamsStore from 'src/utils/hooks/useQueryParamsStore';
import type { BucketInfo } from 'src/stores/BucketStatsStore';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
import useBucketLabel from 'src/utils/hooks/useBucketLabel';
import { BUCKETS } from 'src/stores/JobApplicationStore/types';

export interface BucketButtonProps {
  bucketInfo: BucketInfo;
}
export const BucketButton: React.FC<BucketButtonProps> = observer(
  ({ bucketInfo }) => {
    const { t } = useTranslations(translations);
    const { jobApplicationStore } = useStores();
    const { bucket: selectedBucket } = jobApplicationStore;
    const isBucketSelected = selectedBucket === bucketInfo.type;
    const [, setQueryQueryParams] = useQueryParamsStore();
    const { getLabelFromBucket } = useBucketLabel();

    return (
      <Box>
        <Box
          key={bucketInfo.type}
          component="button"
          cursor="pointer"
          width="full"
          data-testid="desktop-buckets"
          borderRadius="standard"
          paddingBottom="xxsmall"
          className={styles.bucketButtonHover}
          onClick={() => {
            if (jobApplicationStore.bucket !== bucketInfo.type) {
              jobApplicationStore.clearAllSelected();
            }
            setQueryQueryParams.navigateToBucket(bucketInfo.type);
          }}
        >
          <Box
            paddingY="small"
            display="flex"
            justifyContent="spaceBetween"
            data-testid="item"
          >
            <Columns space="small">
              <Column width="content">
                <Inline space="small" align="center">
                  <Text
                    size="small"
                    weight={isBucketSelected ? 'strong' : 'regular'}
                    tone={bucketInfo.count === 0 ? 'secondary' : undefined}
                  >
                    <>{getLabelFromBucket(bucketInfo.type)}</>
                  </Text>
                </Inline>
              </Column>
              <Column width="content">
                {bucketInfo.newCount && bucketInfo.newCount > 0 ? (
                  <Badge bleedY tone="positive">{`${bucketInfo.newCount} ${t(
                    'New Badge label',
                  )}`}</Badge>
                ) : undefined}
              </Column>
            </Columns>
            <Badge
              tone="neutral"
              bleedY
              data={
                bucketInfo.type === BUCKETS.NOT_SUITABLE
                  ? {
                      intercomid: 'Not Suitable',
                    }
                  : {}
              }
            >
              {bucketInfo.count.toString()}
            </Badge>
          </Box>
        </Box>
        {isBucketSelected && jobApplicationStore.isInBucketMode && (
          <Box className={styles.bucketUnderline} />
        )}
      </Box>
    );
  },
);
